import React from 'react';
import { highLightSearchTermEndPositions } from '../../../utils/string-helpers/highlight-search-terms';
import HighlightedWord from './highlighted-word';

type Props = {
  searchValue: string;
  resultText: string;
};

export default function HighlightedText({ searchValue, resultText }: Props) {
  const highlightPositions = highLightSearchTermEndPositions(searchValue, resultText);
  return highlightPositions
    .map(([word, length], index) => (
      <HighlightedWord key={index} text={word} highlightLength={length} />
    ))
    .reduce(
      (acc, x) =>
        acc === null ? (
          x
        ) : (
          <>
            {acc} {x}
          </>
        ),
      null,
    );
}
